export const ALL_ITEM_GOLD = [
    {
      categry: "gold",
      itemList: [
        {
          itemSelected: "fiorella",
          itemName: "Fiorella",
          itemDescription:
            "Fiorella is a customized packaging for gold. Our professional team has designed the packaging to protect your precious gold.",
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],
          itemDesktopBig: [
            "/images/listItem/customizedProjects/Gold/Desktop/fiorella/700x700px/lussopack-goldbox-fiorella-01.webp",          
            "/images/listItem/customizedProjects/Gold/Desktop/fiorella/700x700px/lussopack-goldbox-fiorella-02.webp",          
            "/images/listItem/customizedProjects/Gold/Desktop/fiorella/700x700px/lussopack-goldbox-fiorella-03.webp",                 
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/Gold/Desktop/fiorella/130x130px/lussopack-goldbox-fiorella-01.webp",
            "/images/listItem/customizedProjects/Gold/Desktop/fiorella/130x130px/lussopack-goldbox-fiorella-02.webp",
            "/images/listItem/customizedProjects/Gold/Desktop/fiorella/130x130px/lussopack-goldbox-fiorella-03.webp",
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/Gold/Mobile/fiorella/335x335px/lussopack-goldbox-fiorella-01.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/fiorella/335x335px/lussopack-goldbox-fiorella-02.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/fiorella/335x335px/lussopack-goldbox-fiorella-03.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/Gold/Mobile/fiorella/100x100px/lussopack-goldbox-fiorella-01.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/fiorella/100x100px/lussopack-goldbox-fiorella-02.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/fiorella/100x100px/lussopack-goldbox-fiorella-03.webp",
          ],
        },
        {
          itemSelected: "gino",
          itemName: "Gino",
          itemDescription:
            "Gino is a customized packaging for gold. Our professional team has designed the packaging to protect your precious gold.",
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],
          itemDesktopBig: [
            "/images/listItem/customizedProjects/Gold/Desktop/gino/700x700px/lussopack-goldbox-gino-01.webp",          
            "/images/listItem/customizedProjects/Gold/Desktop/gino/700x700px/lussopack-goldbox-gino-02.webp",          
            "/images/listItem/customizedProjects/Gold/Desktop/gino/700x700px/lussopack-goldbox-gino-03.webp",                 
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/Gold/Desktop/gino/130x130px/lussopack-goldbox-gino-01.webp",
            "/images/listItem/customizedProjects/Gold/Desktop/gino/130x130px/lussopack-goldbox-gino-02.webp",
            "/images/listItem/customizedProjects/Gold/Desktop/gino/130x130px/lussopack-goldbox-gino-03.webp",
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/Gold/Mobile/gino/335x335px/lussopack-goldbox-gino-01.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/gino/335x335px/lussopack-goldbox-gino-02.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/gino/335x335px/lussopack-goldbox-gino-03.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/Gold/Mobile/gino/100x100px/lussopack-goldbox-gino-01.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/gino/100x100px/lussopack-goldbox-gino-02.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/gino/100x100px/lussopack-goldbox-gino-03.webp",
          ],
        },
        {
          itemSelected: "adelina",
          itemName: "Adelina",
          itemDescription:
            "Adelina is a customized packaging for gold. Our professional team has designed the packaging to protect your precious gold.",
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],
          itemDesktopBig: [
            "/images/listItem/customizedProjects/Gold/Desktop/Adelina/700x700px/lussopack-goldbox-adelina-01.webp",          
            "/images/listItem/customizedProjects/Gold/Desktop/Adelina/700x700px/lussopack-goldbox-adelina-02.webp",                         
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/Gold/Desktop/Adelina/130x130px/lussopack-goldbox-adelina-01.webp",
            "/images/listItem/customizedProjects/Gold/Desktop/Adelina/130x130px/lussopack-goldbox-adelina-02.webp",
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/Gold/Mobile/Adelina/335x335px/lussopack-goldbox-adelina-01.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/Adelina/335x335px/lussopack-goldbox-adelina-02.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/Gold/Mobile/Adelina/100x100px/lussopack-goldbox-adelina-01.webp",
            "/images/listItem/customizedProjects/Gold/Mobile/Adelina/100x100px/lussopack-goldbox-adelina-02.webp",
          ],
        },
      ],
    },
  ];
  